// extracted by mini-css-extract-plugin
export default {"ConsructorColumns":"burger-constructor_ConsructorColumns__7KOxw"};